var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{class:('class'in _vm.$attrs) ? _vm.$attrs.class: 'text-h5',attrs:{"color":('color' in _vm.$attrs) ? _vm.$attrs.color : 'black',"opacity":('opacity' in _vm.$attrs) ? _vm.$attrs.opacity : .9}},[_c('img',{attrs:{"src":require('@/assets/ehicond.svg'),"width":"80px"}}),_c('p',{staticClass:"mt-5 mx-3"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }